import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { tokens } from '@/locales/tokens'

type Tokens = {
  [key: string]: { [key: string]: string }
}

const useTranslate = (context: string) => {
  if (!context) {
    throw new Error(`i18n error - context missing`)
  }

  const { t } = useTranslation()

  const refObj: { [key: string]: string } = (tokens as Tokens)[context]

  if (!refObj) {
    throw new Error(
      `i18n error - context ${context} does not exist on tokens ${JSON.stringify(
        tokens
      )}`
    )
  }

  const translate = useCallback(
    (key: string, options?: any) => {
      const refString: string = refObj[key]

      if (!refString) {
        console.warn(
          `Translation warning - missing translation for path ${context}, key ${key}`
        )
        return key // Retourne la clé comme fallback
      }

      if (options) {
        return t(refString, options) as unknown as string
      } else {
        return t(refString) as unknown as string
      }
    },
    [context, refObj, t]
  )

  return { t: translate }
}

export default useTranslate
